(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-behind-the-press"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll(".hover-media-wrapper");

  wrappers.forEach(wrap => {
    const video = wrap.querySelector("video");
    if (!video) return;

    /* ------------------------- */
    /* DESKTOP HOVER BEHAVIOUR  */
    /* ------------------------- */
    wrap.addEventListener("mouseenter", () => {
      video.currentTime = 0;
      video.play();
      wrap.classList.add("active");
    });

    wrap.addEventListener("mouseleave", () => {
      video.pause();
      video.currentTime = 0;
      wrap.classList.remove("active");
    });

    /* ----------------------------------- */
    /* MOBILE — TAP TO PLAY (no controls)  */
    /* ----------------------------------- */
    wrap.addEventListener("touchstart", () => {
      video.play();
      wrap.classList.add("active");
    });

    /* ------------------------------------------------------------- */
    /* MOBILE — AUTO-PLAY WHEN CARD SLIDES INTO VIEW (slider effect) */
    /* ------------------------------------------------------------- */
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            video.play();
            wrap.classList.add("active");
          } else {
            video.pause();
            video.currentTime = 0;
            wrap.classList.remove("active");
          }
        });
      },
      { threshold: 0.6 } // play only when at least 60% visible
    );

    observer.observe(wrap);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector("[data-description-wrapper]");
  if (wrapper) {
    const shortDesc   = wrapper.querySelector("[data-description-short]");
    const fullDesc    = wrapper.querySelector("[data-description-full]");
    const readMoreBtn = wrapper.querySelector("[data-read-more-toggle]");

    if (shortDesc && fullDesc && readMoreBtn) {

      fullDesc.querySelectorAll("p").forEach(p => {
        const text = p.textContent.trim();
        if (!text || p.innerHTML.trim() === "&nbsp;" || p.innerHTML.trim() === "<br>") {
          p.remove();
        }
      });

      fullDesc.style.maxHeight = "0px";
      readMoreBtn.setAttribute("aria-expanded", "false");

      const readLessBtn = document.createElement("button");
      readLessBtn.type = "button";
      readLessBtn.className = readMoreBtn.className;
      readLessBtn.textContent = "Read less";
      fullDesc.appendChild(readLessBtn);

      fullDesc.style.minHeight = shortDesc.offsetHeight + "px";

      readMoreBtn.addEventListener("click", () => {
        wrapper.classList.add("is-expanded");
        readMoreBtn.setAttribute("aria-expanded", "true");
        fullDesc.style.maxHeight = fullDesc.scrollHeight + "px";
      });

      readLessBtn.addEventListener("click", () => {
        fullDesc.style.maxHeight = fullDesc.scrollHeight + "px";
        requestAnimationFrame(function () {
          wrapper.classList.remove("is-expanded");
          readMoreBtn.setAttribute("aria-expanded", "false");
          fullDesc.style.maxHeight = "0px";
        });
      });

      fullDesc.addEventListener("transitionend", function (event) {
        if (event.propertyName !== "max-height") return;
        if (wrapper.classList.contains("is-expanded")) {
          fullDesc.style.maxHeight = "none";
        }
      });
    }
  }


  (function initProductVariantPickers() {
    var pickers = document.querySelectorAll("[data-variant-picker]");
    if (!pickers.length) return;

    function closeVariantPanel(picker) {
      var panel = picker.querySelector("[data-variant-panel]");
      var trigger = picker.querySelector("[data-variant-trigger]");
      if (!panel || !trigger) return;
      panel.setAttribute("hidden", "");
      panel.hidden = true;
      picker.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
    }

    document.addEventListener(
      "click",
      function (e) {
        if (e.target.closest && e.target.closest("[data-variant-picker]")) return;
        pickers.forEach(closeVariantPanel);
      },
      false
    );

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      pickers.forEach(closeVariantPanel);
    });

    pickers.forEach(function (picker) {
      var root = document.getElementById("product-page-root");
      var sectionEl =
        picker.closest("section.product-page-section") ||
        (root && root.querySelector("section.product-page-section")) ||
        (picker.dataset.sectionId && document.getElementById(picker.dataset.sectionId));
      if (!sectionEl) return;

      var trigger = picker.querySelector("[data-variant-trigger]");
      var panel = picker.querySelector("[data-variant-panel]");
      var displayEl = picker.querySelector("[data-variant-display]");
      var variantInput = sectionEl.querySelector(
        "form.product-page__variant-form input[name=\"id\"]"
      );
      var currentPriceEl = sectionEl.querySelector("[data-current-price]");
      var comparePriceEl = sectionEl.querySelector("[data-compare-price]");

      if (!trigger || !panel || !variantInput) return;

      function isPanelClosed() {
        return panel.hasAttribute("hidden") || panel.hidden;
      }

      function openPanel() {
        panel.removeAttribute("hidden");
        panel.hidden = false;
        picker.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
      }

      function togglePanel() {
        if (isPanelClosed()) openPanel();
        else closeVariantPanel(picker);
      }

      trigger.addEventListener("click", function () {
        togglePanel();
      });

      picker.querySelectorAll(".product-page__variant-option").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var id = btn.getAttribute("data-variant-id");
          var priceMoney = btn.getAttribute("data-variant-price-money");
          var compareMoney = btn.getAttribute("data-variant-compare-money");
          var labelEl = btn.querySelector(".product-page__variant-option-label");
          var label = labelEl ? labelEl.textContent.trim() : "";

           sectionEl.querySelectorAll('input[name="id"]').forEach(function(input) {
            input.value = id;
          });
          sectionEl.setAttribute('data-selected-variant-id', id);
          if (displayEl && label) {
            displayEl.textContent = label;
            displayEl.classList.remove("product-page__variant-display--placeholder");
          }
          if (currentPriceEl) {
            currentPriceEl.textContent = priceMoney || "";
          }

          if (comparePriceEl) {
            if (compareMoney) {
              comparePriceEl.textContent = compareMoney;
              comparePriceEl.hidden = false;
            } else {
              comparePriceEl.textContent = "";
              comparePriceEl.hidden = true;
            }
          }

          picker.querySelectorAll(".product-page__variant-option").forEach(function (b) {
            b.classList.toggle("is-active", b === btn);
            b.setAttribute("aria-selected", b === btn ? "true" : "false");
          });

          variantInput.dispatchEvent(new Event("change", { bubbles: true }));
          if (typeof window.__productPageSyncBatch === "function") {
            window.__productPageSyncBatch(sectionEl);
          }
          closeVariantPanel(picker);
        });
      });
    });
  })();

 
  (function initBatchAddToCart() {
    var root = document.getElementById("product-page-root");
    if (!root) return;

    function getSectionFromTarget(el) {
      return el.closest("section.product-page-section");
    }

    function isSizeSelectionRequired(sectionEl) {
      var picker = sectionEl && sectionEl.querySelector("[data-variant-picker]");
      if (!picker) return false;
      var display = picker.querySelector("[data-variant-display]");
      if (!display) return false;
      return display.classList.contains("product-page__variant-display--placeholder");
    }

    function getVariantInput(sectionEl) {
      return sectionEl && sectionEl.querySelector('form.product-page__variant-form input[name="id"]');
    }

    function getBatchAtcRoot(sectionEl) {
      return sectionEl && sectionEl.querySelector("[data-batch-atc-root]");
    }

    function getVariantOptionButton(sectionEl, variantId) {
      if (!sectionEl || !variantId) return null;
      return sectionEl.querySelector(
        '.product-page__variant-option[data-variant-id="' + String(variantId).trim() + '"]'
      );
    }

    function isVariantSoldOutFromOption(opt) {
      if (!opt) return false;
      return opt.getAttribute("data-variant-batch-oos") === "true";
    }

    function isSelectedVariantSoldOut(sectionEl) {
      var input = getVariantInput(sectionEl);
      var rawId = input ? String(input.value).trim() : "";
      if (!rawId) return false;
      var opt = getVariantOptionButton(sectionEl, rawId);
      return isVariantSoldOutFromOption(opt);
    }

    function isSelectedVariantPurchasable(sectionEl) {
      return !isSelectedVariantSoldOut(sectionEl);
    }

    function syncBatchPurchaseState(sectionEl) {
      var wrap = getBatchAtcRoot(sectionEl);
      if (!wrap) return;
      var atc = wrap.querySelector("[data-batch-atc]");
      var sold = wrap.querySelector("[data-batch-sold-out]");
      var err = wrap.querySelector("[data-batch-atc-error]");
      if (!atc || !sold) return;

      if (isSelectedVariantSoldOut(sectionEl)) {
        atc.hidden = true;
        sold.hidden = false;
      } else {
        atc.hidden = false;
        sold.hidden = true;
      }

      if (err) {
        err.textContent = "";
        err.hidden = true;
      }
    }

    window.__productPageSyncBatch = syncBatchPurchaseState;

    document.querySelectorAll('section.product-page-section form.product-page__variant-form input[name="id"]').forEach(
      function (inp) {
        inp.addEventListener("change", function () {
          var sec = inp.closest("section.product-page-section");
          if (sec) syncBatchPurchaseState(sec);
        });
      }
    );

    document.querySelectorAll("section.product-page-section [data-batch-atc-root]").forEach(function (wrap) {
      var sec = wrap.closest("section.product-page-section");
      if (sec) syncBatchPurchaseState(sec);
    });

    document.addEventListener(
      "click",
      function (e) {
        var btn = e.target.closest("[data-batch-atc]");
        if (!btn) return;
        e.preventDefault();

        var sectionEl = getSectionFromTarget(btn);
        if (!sectionEl) return;

        if (isSizeSelectionRequired(sectionEl)) {
          return;
        }

        var input = getVariantInput(sectionEl);
        if (!input || !input.value) {
          return;
        }

        var rawId = String(input.value).trim();
        if (!rawId) {
          return;
        }

        var variantId = parseInt(rawId, 10);
        if (isNaN(variantId)) {
          return;
        }

        if (isSelectedVariantSoldOut(sectionEl)) {
          return;
        }

        if (btn.hidden) {
          return;
        }

        btn.disabled = true;
        var cartUrl = root.dataset.cartUrl || "/cart";

        fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                var desc = (data && (data.description || data.message)) || "";
                var err = new Error(desc || "Could not add to cart.");
                err._apiBody = data;
                throw err;
              });
            }
            return res.json();
          })
          .then(function () {
            window.location.assign(cartUrl);
          })
          .catch(function () {
            window.location.assign(cartUrl);
          });
      },
      false
    );
  })();

  (function initSizeValidation() {
    function getSection(el) {
      return el.closest("section.product-page-section");
    }

    function isPlaceholder(sectionEl) {
      var display = sectionEl && sectionEl.querySelector("[data-variant-display]");
      return display && display.classList.contains("product-page__variant-display--placeholder");
    }

    function showError(sectionEl) {
      var errorEl = sectionEl.querySelector("[data-variant-error]");
      var picker  = sectionEl.querySelector("[data-variant-picker]");
      if (errorEl) {
        errorEl.hidden = false;
      }
      if (picker) {
        picker.classList.add("has-error");
        picker.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    function clearError(sectionEl) {
      var errorEl = sectionEl.querySelector("[data-variant-error]");
      var picker  = sectionEl.querySelector("[data-variant-picker]");
      if (errorEl) errorEl.hidden = true;
      if (picker)  picker.classList.remove("has-error");
    }

    /* Intercept form submit */
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form.classList.contains("product-page__add-to-cart-form")) return;
      var sectionEl = getSection(form);
      if (!sectionEl) return;
      if (!sectionEl.querySelector("[data-variant-picker]")) return; 
      if (isPlaceholder(sectionEl)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError(sectionEl);
      }
    }, true); 

    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".product-page__variant-option");
      if (!btn) return;
      var sectionEl = getSection(btn);
      if (sectionEl) clearError(sectionEl);
    });
  })();


const root = document.getElementById("product-page-root");
if (root) {
  const productHandle = root.dataset.productHandle;
  const isLoggedIn = root.dataset.customerLoggedIn === "true";
  const STORAGE_KEY = "waitlist_completed_" + productHandle;

  const addToCartWrapper = document.getElementById("add-to-cart-wrapper");
  const waitlistWrapper = document.getElementById("waitlist-wrapper");

  if (addToCartWrapper && waitlistWrapper) {
    function showAddToCart() {
      if (!isLoggedIn) return;
      waitlistWrapper.style.display = "none";
      addToCartWrapper.style.display = "block";
      sessionStorage.setItem(STORAGE_KEY, "true");
    }

    if (isLoggedIn && sessionStorage.getItem(STORAGE_KEY) === "true") {
      showAddToCart();
    } else {
      let modalWasOpen = false;

      const observer = new MutationObserver(() => {
        const modal = document.querySelector(".react-responsive-modal-modal.pp-modal");

        if (modal && !modalWasOpen) {
          modalWasOpen = true;
          return;
        }

        if (!modal && modalWasOpen) {
          modalWasOpen = false;
          if (isLoggedIn) {
            showAddToCart();
          }
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }
}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-image-sequence"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Only run on desktop (floating menu is hidden on mobile)
    if (window.innerWidth <= 1024) return;

    const floatingMenu = document.querySelector('.floating-product-menu');
    const sequenceComponent = document.querySelector('scroll-image-sequence-component');
    
    if (!floatingMenu || !sequenceComponent) return;

    // Menu is fixed at top: 125px from viewport top
    const MENU_TOP_OFFSET = 125;
    
    let ticking = false;
    let isMenuHidden = false;

    function checkMenuVisibility() {
      if (!floatingMenu || !sequenceComponent) return;

      const sequenceRect = sequenceComponent.getBoundingClientRect();
      
      // Menu's viewport position (fixed at 125px from top)
      const menuViewportTop = MENU_TOP_OFFSET;
      const menuViewportBottom = menuViewportTop + floatingMenu.offsetHeight;
      
      // Check if menu's vertical position overlaps with sequence component in viewport
      // Menu overlaps if:
      // - Menu top (125px) is within sequence bounds, OR
      // - Menu bottom is within sequence bounds, OR
      // - Menu completely covers sequence, OR
      // - Sequence completely covers menu
      const menuOverlaps = (
        (menuViewportTop >= sequenceRect.top && menuViewportTop <= sequenceRect.bottom) ||
        (menuViewportBottom >= sequenceRect.top && menuViewportBottom <= sequenceRect.bottom) ||
        (menuViewportTop <= sequenceRect.top && menuViewportBottom >= sequenceRect.bottom) ||
        (sequenceRect.top <= menuViewportTop && sequenceRect.bottom >= menuViewportBottom)
      );
      
      // Also hide if viewport is currently viewing the sequence (even if menu doesn't overlap yet)
      const viewportInSequence = sequenceRect.top < window.innerHeight && sequenceRect.bottom > 0;
      
      // Hide menu if it overlaps with sequence OR if we're viewing the sequence
      const shouldHide = menuOverlaps || viewportInSequence;
      
      if (shouldHide && !isMenuHidden) {
        floatingMenu.style.opacity = '0';
        floatingMenu.style.pointerEvents = 'none';
        floatingMenu.style.transition = 'opacity 0.3s ease';
        isMenuHidden = true;
      } else if (!shouldHide && isMenuHidden) {
        floatingMenu.style.opacity = '1';
        floatingMenu.style.pointerEvents = 'auto';
        isMenuHidden = false;
      }
      
      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(checkMenuVisibility);
        ticking = true;
      }
    }

    // Initial check
    checkMenuVisibility();

    // Listen to scroll events
    window.addEventListener('scroll', requestTick, { passive: true });
    
    // Also listen to resize events in case layout changes
    window.addEventListener('resize', function() {
      if (window.innerWidth <= 1024) {
        // Reset menu visibility on mobile
        if (isMenuHidden) {
          floatingMenu.style.opacity = '';
          floatingMenu.style.pointerEvents = '';
          floatingMenu.style.transition = '';
          isMenuHidden = false;
        }
        return;
      }
      requestTick();
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
